import React from 'react';
import { BID_DESCRIPTIONS } from 'consts';
import DemographicSurveyPrompt from './DemographicSurveyPrompt';
import DemographicSurveyShowSurvey from 'resources/demographic_surveys/DemographicSurveyShowSurvey';
import ReturnToJobsCTA from './ReturnToJobsCTA';

const ApplicationSubmitted = () => {
  return (
    <div className="text-md-left text-center px-2 px-md-3">
      <h2 className="title mb-4">Application submitted!</h2>
      <p className="pb-1">{BID_DESCRIPTIONS.submitted}</p>
      <ReturnToJobsCTA />
      <DemographicSurveyShowSurvey>
        {(showSurvey, loaded) =>
          loaded
            ? showSurvey.show_demographic_survey && (
                <DemographicSurveyPrompt id="survey-prompt" />
              )
            : null
        }
      </DemographicSurveyShowSurvey>
    </div>
  );
};

export default ApplicationSubmitted;
